import {
  formatUnreadBadgeCount,
  NEWSROOM_PATH,
} from '@/shared/hooks/api/regulatoryNews'
import type { NavGroup } from '@/components/layout/types'

export function applyRegulatoryNewsNavBadge(
  navGroups: NavGroup[],
  unreadCount: number
): NavGroup[] {
  const badge = formatUnreadBadgeCount(unreadCount)
  if (!badge) {
    return navGroups
  }

  return navGroups.map((group) => ({
    ...group,
    items: group.items.map((item) => {
      if ('url' in item && item.url === NEWSROOM_PATH) {
        return { ...item, badge }
      }
      return item
    }),
  }))
}
